/**
 * `AW2` · `AW3` — el borde de escritura, disponible para el árbol.
 *
 * Mismo patrón que `contexto-configuracion.tsx` y por la misma razón de fondo:
 * el modal y las acciones de fila lo necesitan y están a dos y tres niveles de
 * la raíz, así que la alternativa es plomería por props a través de la tabla.
 *
 * Hay una segunda razón, y es la que importa: **inyectado, el borde se puede
 * reemplazar por un doble.** `contracts/admin-api/fake.ts` existe para que esta
 * pantalla se pueda ejercer «sin base, sin red y sin el módulo real», y eso sólo
 * es posible si el borde entra por afuera. Un `crearBordeDeEscrituraHttp()`
 * llamado adentro del modal haría que la única forma de probarlo fuera
 * interceptar `fetch`, que es probar el transporte en vez de la pantalla.
 */

import { createContext, useContext } from "react"
import type { BordeDeEscritura } from "./borde-escritura.ts"

/**
 * Sin valor por defecto, igual que la configuración.
 *
 * Un doble por defecto acá haría que un componente montado fuera del proveedor
 * anduviera igual, escribiendo en el aire. Falla en el primer render.
 */
const ContextoBordeEscritura = createContext<BordeDeEscritura | null>(null)

export const ProveedorBordeEscritura = ContextoBordeEscritura.Provider

export function useBordeDeEscritura(): BordeDeEscritura {
  const borde = useContext(ContextoBordeEscritura)
  if (borde === null) {
    throw new Error(
      "useBordeDeEscritura() se llamó fuera de <ProveedorBordeEscritura>. El borde se arma en App.tsx con la configuración ya leída.",
    )
  }
  return borde
}
